import React, { createContext, useContext, useState } from 'react';

const ThemeContext = createContext();

export function ThemeProvider({ children }) {
  const [dark, setDark] = useState(true);
  const [lang, setLang] = useState('he');
  return (
    <ThemeContext.Provider value={{ dark, setDark, lang, setLang }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext);
}

export const T = {
  he: {
    municipalities: 'לקוחות', sites: 'כל האתרים', history: 'היסטוריה', users: 'כל המשתמשים',
    newMuni: '+ הוסף לקוח חדש', delete: 'מחק', save: 'שמור', cancel: 'ביטול',
    moked: '+ מוקד', logout: 'יציאה', adminPanel: 'ADMIN PANEL',
    loading: 'טוען...', noSites: 'אין אתרים עדיין', noUsers: 'אין משתמשים עדיין',
    smsRecipients: 'מנהלי SMS', addRecipient: '+ הוסף נמען',
    newSite: '+ אתר חדש', newUser: '+ משתמש חדש', remove: 'הסר',
    name: 'שם', phone: 'טלפון', role: 'תפקיד', email: 'אימייל', password: 'סיסמה',
    siteName: 'שם האתר', address: 'כתובת', city: 'עיר', muniName: 'שם הלקוח',
    active: 'פעילות במערכת', events: 'אירועים',
    dayMode: 'מצב יום', nightMode: 'מצב לילה',
    mokedTitle: 'מוקד', liveAlerts: 'התראות חיות', totalSites: 'סה"כ אתרים',
    treated: 'טופלו', newAlerts: 'חדשות', municipality: 'לקוח',
    ack: 'אישור קבלה ✓', treat: 'טיפול ביניים ⊘', resolve: 'אפשר סגירה ✓',
    showNotes: 'הוסף טיפול ✓', notesPlaceholder: 'הוסף הערה לטיפול...',
    close: 'סגור', controlRoom: 'חדר בקרה', noAlerts: 'אין התראות פעילות',
    waitingAlerts: 'ממתין להתראות...',
    floor: 'קומה', room: 'חדר',
  },
  en: {
    municipalities: 'Clients', sites: 'All Sites', history: 'History', users: 'All Users',
    newMuni: '+ New Client', delete: 'Delete', save: 'Save', cancel: 'Cancel',
    moked: '+ Control Room', logout: 'Logout', adminPanel: 'ADMIN PANEL',
    loading: 'Loading...', noSites: 'No sites yet', noUsers: 'No users yet',
    smsRecipients: 'SMS Recipients', addRecipient: '+ Add Recipient',
    newSite: '+ New Site', newUser: '+ New User', remove: 'Remove',
    name: 'Name', phone: 'Phone', role: 'Role', email: 'Email', password: 'Password',
    siteName: 'Site Name', address: 'Address', city: 'City', muniName: 'Client Name',
    active: 'active in system', events: 'events',
    dayMode: 'Day Mode', nightMode: 'Night Mode',
    mokedTitle: 'Control Room', liveAlerts: 'Live Alerts', totalSites: 'Total Sites',
    treated: 'Treated', newAlerts: 'New', municipality: 'Client',
    ack: 'Acknowledge ✓', treat: 'In Treatment ⊘', resolve: 'Resolve ✓',
    showNotes: 'Add Note ✓', notesPlaceholder: 'Add treatment note...',
    close: 'Close', controlRoom: 'Control Room', noAlerts: 'No active alerts',
    waitingAlerts: 'Waiting for alerts...',
    floor: 'Floor', room: 'Room',
  },
};

